export default "__VITE_ASSET__e09e709e__"